<template>
  <v-container class="fill-height align-start">
    <v-row class="d-flex flex-column pt-16" justify="start" align="center">
      <!-- <v-img
        eager
        src="@/assets/analyticsEmptyState.svg"
        :max-width="200"
      ></v-img> -->
      <span class="titleEmptyState">
        {{ $t('message.pages.analytics.emptyState1') }}
      </span>
      <span class="subtitleEmptyState">
        {{ $t('message.pages.analytics.emptyState2') }}
      </span>
    </v-row>
  </v-container>
</template>

<script>
export default {
  name: 'EmptyState',
}
</script>

<style lang="scss">
.titleEmptyState {
  font-weight: 500;
  font-size: 24px;
  line-height: 120%;
  color: var(--v-neutral-lighten1);
  margin-top: 24px;
  margin-bottom: 12px;
}

.subtitleEmptyState {
  font-weight: 400;
  font-size: 18px;
  line-height: 120%;
  color: var(--v-neutral-lighten1);
}

.bg-dark,
.theme--dark {
  .titleEmptyState,
  .subtitleEmptyState {
    color: var(--v-neutral-lighten2);
  }
}
</style>
